import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["teamMember", "className", "onClick", "useModal", "moreInfoIconName"];
import React, { useState } from 'react';
import _isNil from 'lodash/isNil';
import { isCloseIcon, isSocialMediaIcon } from './BackgroundImageTeamMember.utils';
import { classNames } from '../../../../../../utils/classname';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../../analytics/components/Event';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import FullImageCard from '../../../../../images/components/ImageCard/variants/FullImageCard';
import TeamMember from '../../TeamMember';
import { TeamMemberPropType } from '../../TeamMember.types';
import StaffTeamMemberModal from '../StaffTeamMember/components/StaffTeamMemberModal';
import './BackgroundImageTeamMember.css';
var defaultProps = {
  className: '',
  onClick: null,
  useModal: true,
  moreInfoIconName: 'arrow-right'
};
export default function BackgroundImageTeamMember(_ref) {
  var teamMember = _ref.teamMember,
    className = _ref.className,
    onClickProp = _ref.onClick,
    useModal = _ref.useModal,
    moreInfoIconName = _ref.moreInfoIconName,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useSemanticUiProps = useSemanticUiProps(),
    getCardProps = _useSemanticUiProps.getCardProps;
  var photo = teamMember.photo,
    name = teamMember.name,
    role = teamMember.role,
    email = teamMember.email,
    phone = teamMember.phone,
    description = teamMember.description,
    locations = teamMember.locations,
    hours = teamMember.hours,
    social = teamMember.social;
  function openModal() {
    setShowModal(true);
  }
  function closeModal() {
    setShowModal(false);
  }
  function onClick(e) {
    var target = e.target;
    if (isCloseIcon(target) || isSocialMediaIcon(target)) {
      return;
    }
    if (!_isNil(onClickProp)) {
      onClickProp();
    } else if (useModal) {
      openModal();
    }
  }
  var TeamMemberModal = /*#__PURE__*/React.createElement(TeamMember, {
    className: "background-image-team-member"
  }, /*#__PURE__*/React.createElement(TeamMember.Photo, {
    src: photo
  }), /*#__PURE__*/React.createElement(TeamMember.Content, null, /*#__PURE__*/React.createElement(TeamMember.Name, {
    name: name
  }), /*#__PURE__*/React.createElement(TeamMember.Role, {
    role: role
  }), /*#__PURE__*/React.createElement(TeamMember.Description, {
    description: description
  }), /*#__PURE__*/React.createElement(TeamMember.Email, {
    email: email
  }), /*#__PURE__*/React.createElement(TeamMember.Phone, {
    phone: phone
  }), /*#__PURE__*/React.createElement(TeamMember.Location, {
    locations: locations
  }), /*#__PURE__*/React.createElement(TeamMember.Social, {
    social: social
  }), /*#__PURE__*/React.createElement(TeamMember.Schedule, {
    hours: hours
  })));
  var finalClassName = classNames(_defineProperty({
    'background-image-team-member': true
  }, className, className));
  return /*#__PURE__*/React.createElement(FullImageCard, _extends({
    image: photo,
    className: finalClassName,
    onClick: onClick,
    event: {
      category: EVENT_CATEGORIES.TEAM_EVENT_CATEGORY,
      action: EVENT_ACTIONS.TEAM_VIEW_MEMBER_EVENT_ACTION,
      label: name
    }
  }, getCardProps(restProps)), /*#__PURE__*/React.createElement(TeamMember.Content, null, useModal && /*#__PURE__*/React.createElement(StaffTeamMemberModal, {
    open: showModal,
    onClose: closeModal,
    teamMember: TeamMemberModal
  }), /*#__PURE__*/React.createElement(TeamMember.Name, {
    name: name
  }), /*#__PURE__*/React.createElement(TeamMember.Role, {
    role: role
  }), /*#__PURE__*/React.createElement(TeamMember.Social, {
    social: social
  }), /*#__PURE__*/React.createElement(TeamMember.MoreInfoButton, {
    onClick: onClick,
    iconName: moreInfoIconName
  })));
}
BackgroundImageTeamMember.defaultProps = defaultProps;